import Swiper from 'swiper/bundle';
import gsap from 'gsap';

export let storiesPopup;

class SPopup {
    constructor(el) {
        this.container = el;
        this.swiperContainer = this.container.querySelector('.js-stories-swiper');
        this.swiperWrapper = this.container.querySelector('.js-stories-swiper-wrapper');
        this.closeBtns = this.container.querySelectorAll('.js-stories-close');
        this.mutedBtnsOn = this.container.querySelectorAll('.js-stories-muted-on');
        this.mutedBtnsOff = this.container.querySelectorAll('.js-stories-muted-off');
        this.progress = this.container.querySelector('.js-stories-progress');
        this.progressItems;
        this.videos;
        this.autoTimeout;
        this.autoDuration = 3000;
        this.onVideoSlide = false;
        this.activeIndex = 0;
        this.animations = [];

        this.handlemuted();
        this.handleClose();
        this.handlePrevNext();
        this.isOpen = false;
    }


    open(data) {
        if (!data || !data.slides) {
            return;
        }

        this.data = data;
        this.buildSlides(data.slides);
        this.initVideos();
        this.initSlider(data.index);
        this.buildProgress();
        // this.handlePause();
        this.isOpen = true;
        this.container.classList.add('_is-open');
        this.container.classList.remove('_is-last', '_is-first');
    }


    buildSlides(slides) {
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }

        this.swiperWrapper.innerHTML = slides;
    }


    initSlider() {
        this.activeIndex = 0;

        this.swiper = new Swiper(this.swiperContainer, {
            speed: 0,
            loop: false,
            initialSlide: 0,
            preventClicks: false,
            touchStartPreventDefault: false,
            allowTouchMove: false,
            keyboard: {
                enabled: true
            },
            navigation: {
                prevEl: this.container.querySelector('.js-stories-prev'),
                nextEl: this.container.querySelector('.js-stories-next')
            },
            on: {
                'afterInit': () => {
                    setTimeout(() => {
                        const currentVideo = this.swiperWrapper.querySelector('.swiper-slide-active .js-stories-video');

                        if (currentVideo) {
                            this.playCurrentVideo();
                        } else {
                            this.updateAutoTimer();
                            this.updateProgress();
                        }
                    }, 0);
                }
            }
        });

        this.swiper.on('slideChange', () => {
            this.activeIndex = this.swiper.activeIndex;
        });

        this.swiper.on('slideChangeTransitionStart', () => {
            this.stopAllVideos();
            this.clearAutoTimeout();
        });

        this.swiper.on('slideChangeTransitionEnd', () => {
            const currentVideo = this.swiperWrapper.querySelector('.swiper-slide-active .js-stories-video');

            setTimeout(() => {
                if (currentVideo) {
                    this.playCurrentVideo();
                } else {
                    this.updateAutoTimer();
                    this.updateProgress();
                }
            }, 1);
        });

        this.swiper.on('click', (swiper, e) => {
            this.stopAllVideos();
            this.clearAutoTimeout();
            this.updateProgress();

            const offset = e.offsetX || e.changedTouches[0].clientX;

            if (offset < this.swiper.width / 2) {
                if (this.swiper.isBeginning) {
                    this.close();
                } else {
                    this.swiper.slidePrev();
                }
            } else {
                if (this.swiper.isEnd) {
                    this.close();
                } else {
                    this.swiper.slideNext();
                }
            }
        });
    }


    initVideos() {
        this.videos = this.container.querySelectorAll('.js-stories-video');
    }

	handlemuted(){
		this.mutedBtnsOn.forEach(btn => {
            btn.addEventListener('click', () => {
                const videos = this.swiperWrapper.querySelectorAll('.js-stories-video');
				this.container.classList.add('_muted')
				videos?.forEach(video => {
					video.muted = true
				})
            });
        });
		this.mutedBtnsOff.forEach(btn => {
            btn.addEventListener('click', () => {
				this.container.classList.remove('_muted')
                const videos = this.swiperWrapper.querySelectorAll('.js-stories-video');
				videos?.forEach(video => {
					video.muted = false
				})
            });
        });
	}

    handleClose() {
        this.closeBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                this.close();
            });
        });

        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                this.close();
            }
        });

        this.container.addEventListener('swiped-up', () => {
            this.close();
        });
    }


    playCurrentVideo() {
        const video = this.swiperWrapper.querySelector('.swiper-slide-active .js-stories-video');
        this.clearProgress();

        const progressItem = this.progressItems[this.activeIndex];
        gsap.killTweensOf(progressItem);

        if (video) {
            video.currentTime = 0;
            video.play();

            video.ontimeupdate = () => {
                const scale = video.currentTime / video.duration;

                gsap.to(
                    progressItem,
                    {
                        duration: 0,
                        scaleX: scale
                    }
                );
            };

            video.onended = () => {
                if (this.swiper.isEnd) {
                    // this.nextCollection();
                    this.close();
                } else {
                    this.swiper.slideNext();
                }
            };
        }
    }


    stopAllVideos() {
        this.videos.forEach(video => {
            video.pause();
        });
    }


    handlePause() {
        this.swiper.slides.forEach((slide, index) => {
            ['mousedown', 'touchstart'].forEach(event => {
                slide.addEventListener(event, () => {
                    this.pauseAutoChange();
                });
            });

            ['mouseup', 'touchend'].forEach(event => {
                slide.addEventListener(event, () => {
                    if (index === this.activeIndex) {
                        this.resumeAutoChange();
                    }
                });
            });
        });
    }


    pauseAutoChange() {
        const currentVideo = this.swiperWrapper.querySelector('.swiper-slide-active .js-stories-video');

        if (currentVideo) {
            currentVideo.pause();
        } else {
            const progressItem = this.progressItems[this.activeIndex];
            gsap.killTweensOf(progressItem);
            this.clearAutoTimeout();
        }
    }


    resumeAutoChange() {
        const currentVideo = this.swiperWrapper.querySelector('.swiper-slide-active .js-stories-video');

        if (currentVideo) {
            currentVideo.play();
        } else {
            const animationProgress = this.animations[this.activeIndex].ratio;
            const timeLeft = (1 - animationProgress) * this.autoDuration;

            this.updateAutoTimer(timeLeft);
            this.updateProgress({
                from: animationProgress,
                duration: timeLeft / 1000
            });
        }
    }


    close() {
        if (!this.isOpen || this.swiper.destroyed) {
            return false;
        }

        this.container.classList.remove('_is-open', '_is-last', '_is-first');
        this.stopAllVideos();
        this.clearAutoTimeout();

        setTimeout(() => {
            this.swiper.destroy(true, true);
            this.swiperWrapper.innerHTML = '';
        }, 500);
    }


    buildProgress() {
        let html = '';

        for (let i = 0; i < this.swiper.slides.length; i++) {
            html += `<div class="stories__progress-item js-stories-progress-item" data-id="${i}">
                        <div class="stories__progress-item-inner js-stories-progress-item-inner"></div>
                    </div>`;
        }

        this.progress.innerHTML = html;
        this.progressItems = this.progress.querySelectorAll('.js-stories-progress-item-inner');
    }


    updateProgress(params = { from: 0, duration: this.autoDuration / 1000 }) {
        this.clearProgress();
        const progressItem = this.progressItems[this.activeIndex];

        this.animations[this.activeIndex] = gsap.fromTo(
            progressItem,
            { scaleX: params.from },
            {
                duration: params.duration,
                scaleX: 1,
                ease: 'none'
            }
        );
    }


    clearProgress() {
        this.progressItems.forEach((item, index) => {
            gsap.killTweensOf(item);

            if (index < this.activeIndex) {
                gsap.to( item, { duration: 0, scaleX: 1 } );
            } else if (index > this.activeIndex) {
                gsap.to( item, { duration: 0, scaleX: 0 } );
            }
        });
    }


    updateAutoTimer(time) {
        this.clearAutoTimeout();

        this.autoTimeout = setTimeout(() => {
            if (this.swiper.isEnd) {
                // this.nextCollection();
                this.close();
            } else {
                this.swiper.slideNext();
            }
        }, time || this.autoDuration);
    }


    handlePrevNext() {
        this.container.addEventListener('swiped-left', () => {
            if (this.swiper.isEnd) {
                this.close();
            } else {
                this.swiper.slideNext();
            }
        });

        this.container.addEventListener('swiped-right', () => {
            if (this.swiper.isBeginning) {
                this.close();
            } else {
                this.swiper.slidePrev();
            }
        });
    }

    clearAutoTimeout() {
        clearTimeout(this.autoTimeout);
    }
}

if (document.querySelector('.js-stories')) {
    storiesPopup = new SPopup(document.querySelector('.js-stories'));
}


// Открыть попап со сторисами
document.querySelectorAll('.menu__icons, .left-menu__top, .js-open-reviews').forEach((link, index) => {
    link.addEventListener('click', e => {
        e.preventDefault();
        const srcId = 'reviews';
        const slidesHtml = document.querySelector(`.js-stories-template[data-id="${srcId}"]`)?.innerHTML;

        if (!srcId || !slidesHtml) {
            return;
        }

        const popupData = {
            index: index,
            slides: slidesHtml
        };

        storiesPopup?.open(popupData);
    });
});
